import { Typography } from "@mui/material";
import styled from "@mui/material/styles/styled";

import type {
  ApiEntityAccessView,
  GeneralAccessLevel,
  GeneralAccessPattern,
} from "@app/common/types";
import { pluralize } from "@app/common/utils";

import ConfirmationModal, {
  ConfirmationModalProps,
} from "@rui/ConfirmationModal";

export interface PendingAccessChange {
  accessLevel: GeneralAccessLevel;
  accessPattern: GeneralAccessPattern;
  affectedEntities: ApiEntityAccessView[];
}

interface LinkAccessUpdateConfirmProps
  extends Omit<ConfirmationModalProps, "children" | "open"> {
  pendingUpdate: PendingAccessChange | null;
}

const Bold = styled("span")({ fontWeight: 500 });

const LinkAccessUpdateConfirm = ({
  pendingUpdate,
  ...modalProps
}: LinkAccessUpdateConfirmProps) => {
  if (pendingUpdate == null) return null;

  const numAffectedEntities = pendingUpdate.affectedEntities.length;

  return (
    <ConfirmationModal
      {...modalProps}
      open
      title="Update all to full report access?"
      size="md"
    >
      <Typography sx={{ color: "shades.neutral.600", lineHeight: 20 / 16 }}>
        Currently, {numAffectedEntities}{" "}
        {pluralize("person has", "people have", numAffectedEntities)}{" "}
        <Bold>recap only</Bold> access. Opening link access to{" "}
        <Bold>full report</Bold> access will update{" "}
        {pluralize(
          "this individual's",
          "all individuals'",
          numAffectedEntities
        )}{" "}
        permissions to full report access.
      </Typography>
    </ConfirmationModal>
  );
};

export default LinkAccessUpdateConfirm;
